<template>
  <div v-if="teammates" class="auth-description spacey-32">
    <h1 class="auth-title">{{ $t('Do you work in') }} “{{ teammates.name }}” {{ 'company' }}?</h1>
    <span class="text text-grey">
      {{ $t('We found out') }}
      “{{ teammates.name }}”
      {{
        $t(
          'company is already registered in Fixtender. Click “Yes” and we add you to your team or click “No” and create new company instead'
        )
      }}
    </span>

    <Teammates
      v-if="teammates.members.length"
      :company="teammates.name"
      :teammates="teammates.members"
    />

    <Form @submit="finishRegistration">
      <FormInput
        id="position"
        v-model="position"
        class="formcell-24"
        required
        :label-text="$t('Enter your position, if you work here')"
        :placeholder="$t('Enter your position')"
      />

      <div class="choose-company__buttons-container spacex-12">
        <Button action-type="submit">
          {{ $t('Yes') }}
        </Button>
        <Button color="neutral" @click="nextStep">
          {{ $t('No') }}
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
  import FormInput from '@/components/ui/FormInput';
  import Button from '@/components/ui/Button';
  import { mapActions, mapState } from 'vuex';
  import Teammates from '@/components/info/Teammates';
  import Form from '@/components/common/Form';
  import factory from '@/utils/api/factory';

  export default {
    name: 'ChooseCompany',
    components: {
      FormInput,
      Button,
      Teammates,
      Form,
    },
    data() {
      return {
        position: '',
        teammates: null,
      };
    },
    async created() {
      await this.getTeammates();
    },
    computed: {
      ...mapState('auth', ['registrationInfo', 'password']),
    },
    methods: {
      ...mapActions('auth', ['login']),
      async getTeammates() {
        try {
          const { data } = await factory('register').indexInPath(
            'search_teammates_by_email_domain'
          );

          this.teammates = data;
        } catch (e) {
          if (e.response?.status === 404) this.$emit('change-step', 3.1);
          else console.error(e);
        }
      },
      async finishRegistration() {
        try {
          await factory('register').postInPath('finish');

          await this.login({
            email: this.registrationInfo.email,
            password: this.password,
          });

          await factory('profile').patch({
            position: this.position,
          });

          await this.$router.push({ name: 'projects' });
          location.reload();
        } catch (e) {
          console.error(e);
        }
      },
      nextStep() {
        this.$emit('change-step', 3.1);
      },
    },
  };
</script>
